"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TILE_SIZE = exports.DEFAULT_MAX_ZOOM = void 0;

/**
 * @module ol/tilegrid/common
 */

/**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */
var DEFAULT_MAX_ZOOM = 42;
/**
 * Default tile size.
 * @type {number}
 */

exports.DEFAULT_MAX_ZOOM = DEFAULT_MAX_ZOOM;
var DEFAULT_TILE_SIZE = 256;
exports.DEFAULT_TILE_SIZE = DEFAULT_TILE_SIZE;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7QUFJTyxJQUFNQSxnQkFBZ0IsR0FBRyxFQUF6QjtBQUVQOzs7Ozs7QUFJTyxJQUFNQyxpQkFBaUIsR0FBRyxHQUExQiIsIm5hbWVzIjpbIkRFRkFVTFRfTUFYX1pPT00iLCJERUZBVUxUX1RJTEVfU0laRSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdGlsZWdyaWQvY29tbW9uLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19